import React from 'react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/919643813920"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:scale-110 hover:shadow-xl transition-transform duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <i className="fab fa-whatsapp text-3xl"></i>
      {/* Optional tooltip */}
      <span className="absolute left-full ml-4 top-1/2 -translate-y-1/2 px-3 py-1.5 bg-black/80 text-white text-[13px] rounded-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity whitespace-nowrap">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;
